import { _post } from "@/utils/https";

const { VITE_APP_AWS } = import.meta.env;

export const reportData = async (params: any) => {
  return _post(`${VITE_APP_AWS}/collect`, params);
};
